import { useState } from 'react';
import usePaidCourses from '../../../hooks/usePaidCourses';

const PodCastCourses = () => {
  const { courses } = usePaidCourses();
  const [additionalResources,setAdditionalResources] = useState(false)
 const myPodcasts = courses?.filter(
  (item) => item.learning_type === 'podcast' && item.podcast !== null
);


  return (
   <div className="min-h-screen px-4 md:px-8 py-6">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Your PodCast Courses</h1>
          <p className="text-sm text-gray-500 mt-0.5">Continue learning from your enrolled courses</p>
        </div>
      </div>

      {myPodcasts?.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-200">
          <div className="w-20 h-20 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-10 h-10 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No podcast courses yet</h3>
          <p className="text-gray-500">Browse courses to start learning</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {myPodcasts?.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all flex flex-col overflow-hidden"
            >
              {/* Video Thumbnail */}
              <div className="w-full h-56 overflow-hidden bg-gray-900">
                <video
                  src={item.podcast?.file}
                  controls
                  preload="metadata"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <h2 className="text-lg font-semibold text-gray-900 line-clamp-2">
                    {item.podcast?.name}
                  </h2>
                </div>

                <p className="text-sm text-gray-600 mb-4 flex-1 leading-relaxed line-clamp-3">
                  {item.podcast?.description?.length > 200
                    ? item.podcast.description.slice(0, 200) + "..."
                    : item.podcast?.description}
                </p>

                {/* Price Badge */}
                <div className="mb-4">
                  <span className={`inline-block px-3 py-1 text-xs font-medium rounded-lg ${
                    item.podcast?.course_type === "free" 
                      ? "bg-green-100 text-green-700" 
                      : "bg-blue-100 text-blue-700"
                  }`}>
                    {item.podcast?.course_type === "free" ? "Free" : `$${item.podcast?.price}`}
                  </span>
                </div>

                {/* Teacher Info */}
                <div className="flex items-center gap-3 mb-4 p-3 bg-gray-50 rounded-xl">
                  <div className="relative">
                    <img
                      src={item.podcast.teacher.user?.profile_image}
                      alt={item.podcast.teacher.user?.name}
                      className="w-10 h-10 rounded-lg object-cover border-2 border-white"
                    />
                    <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                  </div>
                  <div>
                    <h6 className="text-sm font-medium text-gray-900">
                      {item.podcast.teacher.user?.name}
                    </h6>
                    <p className="text-xs text-gray-500">{item.podcast.teacher.user?.email}</p>
                  </div>
                </div>

                {/* Additional Resources */}
                {item?.podcast?.resources?.length > 0 && (
                  <>
                    <button
                      onClick={() => setAdditionalResources(!additionalResources)}
                      className="flex items-center gap-2 text-sm font-medium text-[#0f6abf] bg-[#e8f0f7] px-4 py-2.5 rounded-xl hover:bg-[#d0e0f0] transition-colors mt-2"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      Additional Resources
                    </button>

                    {additionalResources && (
                      <div className="mt-3 space-y-2">
                        {item.podcast.resources.map((resource, index) => (
                          <div
                            key={index}
                            className="bg-gray-50 rounded-xl p-3 border border-gray-200"
                          >
                            <a
                              href={resource.file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center gap-2 text-sm text-[#0f6abf] hover:underline"
                            >
                              <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                              </svg>
                              <span className="truncate">
  {resource.file?.split('/').pop()}
</span>

                            </a>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PodCastCourses;
